<div
  class="flex flex-col bg-no-repeat bg-cover bg-center px-2 py-2 md:py-4 md:px-8 lg:px-12 lg:py-4"
  style="background-image: url('/assets/images/body.webp')"
>
  <div class="w-full flex justify-center mb-4 mt-8 md:mt-12 lg:mt-0 order-2 lg:order-1">
    <app-top-navbar class="w-full max-w-8xl"></app-top-navbar>
  </div>

  <div class="w-full flex justify-center mb-6 order-1 lg:order-2">
    <app-navbar class="w-full max-w-8xl"></app-navbar>
  </div>
  <h1 class="visually-hidden">Commander en ligne - Nos produits</h1>
  <div class="w-full max-w-6xl mx-auto order-3">
    @if (getOrderTypeLabel() && getFormattedLocation().text) {
    <div class="flex items-center justify-center h-auto">
      <div class="address-pill">
        <div class="type-section">
          <p class="type-text"
             [class.text-primary]="isMilano" [class.text-base]="!isMilano">{{ getOrderTypeLabel() }}</p>
            @if (isDelivery) {
    <p class="delay-text">
      Délai : {{ formatDeliveryDelay() }}
    </p>
    }
    </div>
    <div class="location-section"
         [class.bg-primary]="isMilano" [class.bg-secondary/20]="!isMilano">
      <div class="location-info">
        <p class="location-address">{{ getFormattedLocation().text }}</p>
            @if (getMinOrderAmount()) {
    <p class="min-amount">
      {{ getMinOrderAmount() }}
    </p>
    }
    </div>
    <button (click)="openDialog()" class="edit-action">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
</div>
</div>
    }
  </div>
</div>

<div class="flex flex-col bg-body-promo py-4 px-2 md:px-8 lg:px-12">

  <div class="flex justify-end">
    <button
      (click)="openFilterDialog()"
      class="nav-item-dynamic shadow-sm border-2 mb-3 sm:mb-0"
      [class.active]="isFiltersActive || isFilterDialogOpen"
      type="button">
      <mat-icon>filter_list</mat-icon>
      <span class="category-name">Filtre</span>
    </button>
  </div>

  <!-- ═══ PROMOS ═══ -->
  @if (dataPromos.length > 0 || isLoadingPromos()) {
  <div class="flex flex-col gap-3 px-2">
    @if (isLoadingPromos()) {
  <div class="flex flex-col justify-center items-center py-8">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-secondary"></div>
    <span class="ml-2 text-gray-600 mt-2">Chargement des promos...</span>
  </div>
  }
  @if (!isLoadingPromos()) {
  <div>
    @if (dataPromos.length > 0) {
    <div class="flex items-center justify-between mb-3">
      <h2 class="flex items-center gap-2">
        <span class="title text-dark text-[30px]">Liste</span>
        <span class="title text-[30px] text-dark">Promos</span>
      </h2>
    </div>
    }
    <div class="relative">
      @if (canScrollLeft) {
      <button
        (click)="scrollPromosLeft()"
        class="cursor-pointer nav-arrow left-arrow absolute left-2 top-1/2 -translate-y-1/2 z-40 w-9 h-9 bg-base-200 rounded-full shadow-md flex items-center justify-center hover:bg-gray-100 transition-all border border-gray-100">
        <mat-icon class="text-dark">chevron_left</mat-icon>
      </button>
      }
      <div
        #promoScrollContainer
        class="scroll-container flex gap-6 overflow-x-auto scrollbar-hide snap-x"
        (scroll)="updateArrowPromosVisibility()">
        @for (card of dataPromos; track trackById(card)) {
        @if (isOrderOffer(card) || !card._isAvailable) {
        <div
          class="relative flex-shrink-0 rounded-[20px] w-[270px] sm:w-[324px] min-h-[150px] overflow-hidden flex flex-col snap-center border border-white/10 is-disabled"
          [ngStyle]="{
                        'background-image': 'url(/assets/images/background-promos.webp)',
                        'background-size': 'cover',
                        'background-position': 'center',
                        'background-repeat': 'no-repeat'
                      }">
          <div class="absolute inset-0 bg-gradient-to-tr from-black/20 to-transparent pointer-events-none"></div>
          <div
            class="absolute inset-0 backdrop-blur-[1px] bg-base-200/10 z-30 rounded-[20px] pointer-events-none"></div>

          @if (card._availabilityLabel) {
          <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 bg-[#ffffffb8] text-[#000000] text-xs font-bold px-3 py-2 rounded-xl shadow-md uppercase text-badge text-center custom-phone-badge border border-gray-300">
          {{ card._availabilityLabel }}
          </div>
          }

          @if (getPrimaryBadge(card.payload?.activatedFor); as badge) {
          <div class="absolute top-[45px] left-0 z-20 transform -rotate-35 -translate-x-8 -translate-y-8">
            <div class="bg-secondary text-[#FFFFFF] text-[10px] font-bold tracking-wider px-10 py-1 shadow-md border-b border-white/10">
          {{ badge.label }}
          </div>
        </div>
          }

          <div class="relative z-10 flex flex-wrap justify-center gap-3 px-3 mt-6">
            @for (type of card.orderTypes; track type) {
            <span class="bg-[#FFFFFF]/20 backdrop-blur-md border border-[#FFFFFF]/30 text-[#FFFFFF] text-[11px] font-bold px-3 py-1 rounded-[6px] uppercase shadow-sm">
            {{ type }}
            </span>
            }
          </div>

          <div class="relative p-5 h-full flex flex-col justify-end overflow-hidden">
            <div class="relative z-10">
              <p class="text-sm font-black text-[#FFFFFF] leading-[1.2] drop-shadow-lg italic line-clamp-3">
                {{ card.title }}
              </p>
            </div>
          </div>
        </div>
        } @else {
        <a
          [routerLink]="['/nos-promos', card.slug]"
          [queryParams]="isRedeemMode ? {mode: 'redeem'} : null"
          [state]="{
                        promoId: card.id,
                        promoSlug: card.slug,
                        selectedCategoryId: card.categoryId,
                        fromMenu: false,
                        returnCategoryId: null
                      }"
          (click)="redirectVersDetailsPromosSideEffect()"
          class="relative flex-shrink-0 rounded-[20px] w-[270px] sm:w-[324px] min-h-[150px] overflow-hidden cursor-pointer flex flex-col snap-center border border-white/10"
          [ngStyle]="{
                        'background-image': 'url(/assets/images/background-promos.webp)',
                        'background-size': 'cover',
                        'background-position': 'center',
                        'background-repeat': 'no-repeat'
                      }">
          <div class="absolute inset-0 bg-gradient-to-tr from-black/20 to-transparent pointer-events-none"></div>

          @if (getPrimaryBadge(card.payload?.activatedFor); as badge) {
          <div class="absolute top-[45px] left-0 z-20 transform -rotate-35 -translate-x-8 -translate-y-8">
            <div class="bg-secondary text-[#FFFFFF] text-[10px] font-bold tracking-wider px-10 py-1 shadow-md border-b border-white/10">
          {{ badge.label }}
          </div>
        </div>
          }

          <div class="relative z-10 flex flex-wrap justify-center gap-3 px-3 mt-6">
            @for (type of card.orderTypes; track type) {
            <span class="bg-[#FFFFFF]/20 backdrop-blur-md border border-[#FFFFFF]/30 text-[#FFFFFF] text-[11px] font-bold px-3 py-1 rounded-[6px] uppercase shadow-sm">
            {{ type }}
            </span>
            }
          </div>

          <div class="relative p-5 h-full flex flex-col justify-end overflow-hidden">
            <div class="relative z-10">
              <p class="text-sm font-black text-[#FFFFFF] leading-[1.2] drop-shadow-lg italic line-clamp-3">
                {{ card.title }}
              </p>
            </div>
          </div>
        </a>
        }
        }
      </div>
      @if (canScrollRight) {
      <button
        (click)="scrollPromosRight()"
        class="cursor-pointer nav-arrow right-arrow absolute right-2 top-1/2 -translate-y-1/2 z-40 w-9 h-9 bg-base-200 rounded-full shadow-md flex items-center justify-center hover:bg-gray-100 transition-all border border-gray-100">
        <mat-icon class="text-dark">chevron_right</mat-icon>
      </button>
      }
    </div>
  </div>
  }
  </div>
  }
  <!-- ═══ CATÉGORIES ═══ -->
  <div class="w-full mx-auto">
    <div class="categories-scroll-container py-0 md:py-4" #categoriesContainer>
      <div
        #scrollContainer
        class="scroll-container"
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (mouseup)="onMouseUp()"
        (mouseleave)="onMouseLeave()"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (touchend)="onTouchEnd()">

        <div class="categories-list flex items-center gap-2">

          <!-- ── BOUTON FILTRE : Masqué au début (@if), s'affiche UNIQUEMENT quand un filtre est actif ── -->
          @if (isFiltersActive || activeFiltersCount > 0) {
          <button
            (click)="openFilterDialog()"
            class="nav-item-dynamic shadow-sm border-2 flex items-center gap-2 cursor-pointer active"
            type="button">
            <mat-icon>filter_list</mat-icon>
            <span class="category-name">Filtre</span>
            @if (activeFiltersCount > 0) {
          <span class="bg-secondary text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center ml-1">
                {{ activeFiltersCount }}
              </span>
          }
          </button>
          }

          <!-- ── LISTE DES CATÉGORIES ── -->
          @for (item of data(); track item) {
          @if (item.products !== 0) {
          <a
            [routerLink]="['/product/category', item.slug]"
            [queryParams]="{
        page: 0,
        mode: isRedeemMode ? 'redeem' : null,
        category: null,
        ingredients: null,
        flags: null,
        plusLabels: null,
        minusLabels: null
      }"
            (click)="selectCategory(item.id)"
            draggable="false"
            class="nav-item-dynamic shadow-sm border-2"
            [class.active]="item.isActive && !isMenusActive && !isPromosActive && !isFiltersActive && activeFiltersCount === 0"
            type="button">
            @if (item.metadata?.icon) {
            <img
              [ngSrc]="item.metadata!.icon"
              [alt]="item.name || 'Image à venir'"
              width="40"
              height="40"
              loading="lazy"
              class="w-10 h-10 object-contain"/>
            }
            <span class="category-name">{{ item.name }}</span>
          </a>
          }
          }

        </div>
      </div>
    </div>
  </div>
  <div class="w-full mx-auto">

    <!-- ═══ MENUS + PRODUITS PAR CATÉGORIE ═══ -->
    @if (!isMenusActive && !isPromosActive && !isFiltersActive) {
    <div class="px-2">
      <div class="grid gap-2 sm:flex sm:items-center sm:justify-between mb-3 px-2">
        @if (!isLoadingMenus() && dataMenus.length > 0) {
    <div class="order-2 sm:order-1 flex justify-start">
      <h2 class="flex items-center gap-2">
        <span class="title text-dark text-[30px] leading-none">Nos</span>
        <span class="title text-dark text-[30px] leading-none">Menus</span>
      </h2>
    </div>
    }
    @if (activeSubcategories.length > 0) {
    <mat-form-field
      appearance="outline"
      class="order-1 sm:order-2 w-full sm:w-[250px]">
      <mat-select
        placeholder="Filtre par sous-catégorie"
        [value]="selectedSubcategoryId"
        (selectionChange)="selectSubcategory($event.value)">
        <mat-option value="">Tous</mat-option>
        @for (sub of activeSubcategories; track sub) {
        <mat-option [value]="sub.id">
        {{ sub.name }} ({{ sub.products }})
            </mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
    </div>

    <!-- ── MENUS ── -->
    @if (dataMenus.length > 0 || isLoadingMenus()) {
    <section class="flex flex-col gap-3 px-2">
      @if (isLoadingMenus()) {
      <div class="flex flex-col justify-center items-center py-8">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-secondary"></div>
        <span class="ml-2 text-gray-600 mt-2">Chargement des menus...</span>
      </div>
      }

      @if (!isLoadingMenus()) {
      <div>
        <div class="relative">
          @if (canScrollBundleLeft) {
      <button (click)="scrollLeftBundle()"
              class="nav-arrow left-arrow absolute left-2 top-1/2 -translate-y-1/2 z-40 w-9 h-9 bg-base-200 rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer border border-gray-100">
        <mat-icon class="text-dark">chevron_left</mat-icon>
      </button>
      }

      <div #menusScrollContainer class="scroll-container flex gap-6 overflow-x-auto scrollbar-hide snap-x">
        @for (card of dataMenus; track card; let i = $index) {

      @if (isMilano) {
      <div class="bundle-item-wrapper w-[295px] flex-shrink-0 snap-center mb-4 rounded-[8px] overflow-hidden bg-cover bg-center text-white relative flex flex-col h-[400px]"
           [style.background-image]="'url(' + getBackgroundImage(i) + ')'"
           [class.is-disabled]="!card._isAvailable">

        @if (card.formattedPrice || card.price) {
      <div
        class="absolute top-3 right-3 z-20 bg-primary text-white text-xs font-bold px-2.5 py-1 rounded-full shadow-md">
        {{ getMenuPrice(card) }}
      </div>
      }

      @if (!card._isAvailable) {
      <div class="absolute inset-0 backdrop-blur-[1px] bg-white/10 z-30 rounded-[8px] pointer-events-none"></div>
      }
      @if (card._availabilityLabel) {
      <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40
                                                  bg-[#ffffffb8] text-badge text-[#000000] text-xs font-bold px-3 py-2 rounded-xl
                                                  shadow-md uppercase text-center custom-phone-badge border border-gray-300">
        {{ card._availabilityLabel }}
      </div>
      }

      <div class="relative z-10 flex flex-col items-center justify-between h-full p-4 pb-5">
        <div class="pt-1">
          <img
            ngSrc="/assets/images/good-food-logo.webp"
            alt="Good Food"
            width="144"
            height="56"
            loading="lazy"
            sizes="10vw"
            class="w-36 drop-shadow-md" />
        </div>

        <div class="relative flex justify-center items-center mt-4 w-[160px] h-[160px] overflow-hidden">
          <img
            [ngSrc]="card.image || 'assets/images/placeholders/placeholder.webp'"
            [alt]="card.name || 'Image à venir'"
            fill
            loading="lazy"
            sizes="15vw"
            class="object-contain p-2 group-hover:scale-110 transition-transform duration-500 drop-shadow-xl" />
        </div>

        <div class="text-center mt-2">
          <h3 class="text-[22px] font-bold uppercase tracking-wider drop-shadow-lg"
              [style.color]="getColorText(i)"
              style="font-family: 'Pattaya', cursive;">
      {{ card.name }}
      </h3>
    </div>
    <div class="mt-4 w-full">
      <a [routerLink]="card._isAvailable ? ['/menus', card.slug] : null"
         [queryParams]="isRedeemMode ? {mode: 'redeem'} : null"
                       [state]="{bundleId: card.id, bundleSlug: card.slug, returnCategoryId: null, fromMenu: true}"
                       [ngClass]="getButtonClass(i)"
                       class="w-44 px-4 py-3 rounded-lg font-bold text-sm tracking-wider flex items-center justify-between gap-2 mx-auto cursor-pointer text-white shadow-md"
                       (click)="card._isAvailable ? redirectVersDetailsBundleSideEffect() : $event.preventDefault()">
                      <span>Commander</span>
                      <mat-icon class="text-lg">shopping_cart</mat-icon>
                    </a>
                  </div>
                </div>
              </div>
      } @else {
      <div class="w-[250px] bundle-item-wrapper shrink-0 snap-center mb-4 cursor-pointer">
        <div class="custom-bundle-card relative rounded-2xl overflow-hidden border border-gray-100 bg-base-200 shadow-sm flex flex-col h-full"
             [class.is-disabled]="!card._isAvailable">

          @if (card.formattedPrice || card.price) {
      <div
        class="absolute top-3 right-3 z-20 bg-primary text-white text-xs font-bold px-2.5 py-1 rounded-full shadow-md">
        {{ getMenuPrice(card) }}
      </div>
      }

      <div class="card-overlay absolute inset-0 pointer-events-none"></div>
      @if (!card._isAvailable) {
      <div class="absolute inset-0 backdrop-blur-[1px] bg-white/40 z-30 rounded-2xl pointer-events-none"></div>
      }
      @if (card._availabilityLabel) {
      <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40
                                                    bg-[#ffffffb8] text-badge text-[#000000] text-xs font-bold px-3 py-2 rounded-xl shadow-md
                                                    uppercase text-center custom-phone-badge border border-gray-300">
        {{ card._availabilityLabel }}
      </div>
      }
      <div class="relative w-full h-[200px] bg-transparent flex items-center justify-center p-4 overflow-hidden">
        <img
          [ngSrc]="card.image || 'assets/images/placeholders/placeholder.webp'"
          [alt]="card.name || 'Image à venir'"
          width="200"
          height="200"
          loading="lazy"
          class="max-w-full max-h-full w-auto h-auto object-contain group-hover:scale-110 transition-transform duration-500 drop-shadow-xl" />
      </div>
      <div class="p-4 flex justify-between items-end bundle-text-section grow">
        <div class="flex-1 min-w-0">
          <h3 class="bundle-title text-[22px] text-dark font-primary leading-tight mb-1">
      {{ card.name }}
      </h3>
    </div>
    <a [routerLink]="card._isAvailable ? ['/menus', card.slug] : null"
       [queryParams]="isRedeemMode ? {mode: 'redeem'} : null"
                       [state]="{bundleId: card.id, bundleSlug: card.slug, returnCategoryId: null, fromMenu: true}"
                       class="bundle-cart-btn w-12 h-12 bg-primary text-white flex justify-center items-center rounded-full hover:scale-110 transition-all cursor-pointer shadow-lg shadow-primary/20"
                       (click)="card._isAvailable ? redirectVersDetailsBundleSideEffect() : $event.preventDefault()">
                      <mat-icon class="text-[22px]">shopping_cart</mat-icon>
                    </a>
                  </div>
                </div>
              </div>
      }
      }
      </div>

      @if (canScrollBundleRight) {
      <button (click)="scrollRightBundle()"
              class="nav-arrow right-arrow absolute right-2 top-1/2 -translate-y-1/2 z-40 w-9 h-9 bg-base-200 rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer border border-gray-100">
        <mat-icon class="text-dark">chevron_right</mat-icon>
      </button>
      }
      </div>
    </div>
      }
    </section>
    }

    <!-- ── LOADING PRODUITS ── -->
    @if (isLoading()) {
    <div class="flex justify-center items-center min-h-[400px]">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-secondary"></div>
      <span class="ml-2 text-gray-600">Chargement en cours...</span>
    </div>
    }

    <!-- ── LISTE PRODUITS ── -->
    @if (!isLoading() && productsByCategory) {
    <div class="grid grid-cols-1 gap-8">
      <div>
        <div class="flex items-center justify-start mb-6 px-2">
          <h2 class="flex items-center gap-2">
            <span class="title text-dark text-[30px]">Liste</span>
            <span class="title text-dark text-[30px]">Produits</span>
          </h2>
        </div>
        @if (productsByCategory.length === 0) {
        <h3 class="text-dark text-xl text-center">Aucun produit n'a été trouvé dans la catégorie <b>{{
        selectedCategory() }}</b>.</h3>
        }
        @for (group of groupedProductsByCategory; track group.label) {
        @if (group.label) {
        <div class="flex items-center gap-3 mt-6 mb-4 px-2">
          <span class="w-1 h-6 bg-primary rounded-full"></span>
          <span class="font-bold text-lg text-dark">{{ group.label }}</span>
          <span class="bg-primary/10 text-primary text-xs font-bold px-2 py-1 rounded-full">
              {{ group.products.length }}
            </span>
        </div>
        }
        <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
          @for (product of group.products; track trackByProductId(product)) {
        <div
          class="bg-base-200 rounded-box overflow-hidden transition-all duration-300 flex flex-col relative max-h-[450px] w-full"
          [class.is-disabled]="!product._isAvailable">
          @if (!product._isAvailable) {
          <div class="absolute inset-0 backdrop-blur-[1px] bg-white/40 z-30 rounded-box pointer-events-none"></div>
          }
          @if (product._availabilityLabel) {
          <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40
                      bg-[#ffffffb8] text-badge text-[#000000] font-bold px-3 py-2 rounded-xl shadow-md uppercase
                      text-center custom-phone-badge border border-gray-300">
          {{ product._availabilityLabel }}
          </div>
          }
          @let discountInfo = getProductDiscountInfo(product.id, product.selectedSize, product.categoryId);

          <!-- ═══ DISCOUNT BADGES (masqués si mode redeem) ══════════ -->
          @if (discountInfo && !isRedeemMode) {
          @if (formatReduction(discountInfo.reduction)) {
          <div class="absolute top-2 left-2 z-20">
                <span class="bg-[#EB3D08] text-white text-xs font-bold px-2 py-1 rounded-full shadow-md">
                  {{ formatReduction(discountInfo.reduction) }}
                </span>
          </div>
          }
          @if (getDiscountClientBadge(discountInfo.activatedFor); as clientBadge) {
          <div class="absolute top-2 right-2 z-20">
                <span
                  class="bg-secondary text-white text-xs font-bold px-2 py-1 rounded-full tracking-wider shadow-md border-b border-white/10 animate-pulse">
                  {{ clientBadge.label }}
                </span>
          </div>
          }
          }

          <div class="relative w-full h-[200px] overflow-hidden rounded-[12px] p-3">
            <img
              [ngSrc]="product.cover || 'assets/images/placeholders/placeholder.webp'"
              [alt]="product.name || 'Image à venir'"
              fill
              loading="lazy"
              sizes="(max-width: 640px) 50vw,
                                     (max-width: 1024px) 33vw,
                                     25vw"
              class="object-contain rounded-[12px]"/>
          </div>
          <div class="px-3 pb-3 space-y-3 flex flex-col flex-1">
            <h3 class="font-bold text-[16px] md:text-[18px] text text-dark text-center">
              {{ product.name }}
            </h3>

            <!-- ── Multiple sizes ── -->
            @if (hasMultiplePrices(product)) {
            <div class="flex flex-col md:flex-row items-center justify-between gap-2">
              @if (discountInfo && !isRedeemMode) {
            @if (product.selectedPrice && !isNaN(product.selectedPrice)) {
            <div class="flex flex-col items-start">
              <span class="text-[13px] line-through text-site whitespace-nowrap">
            {{ displayPrice(product.selectedPrice, product.currency) }}
            </span>
            <span class="text-[16px] font-bold text-red-500 whitespace-nowrap">
            {{ displayPrice(calculateDiscountedPrice(product.selectedPrice, discountInfo.reduction), product.currency) }}
            </span>
          </div>
            }
            } @else {
            @if (product.selectedPrice && !isNaN(product.selectedPrice)) {
            <span class="text-[16px] font-bold text-dark whitespace-nowrap">
            {{ displayPrice(product.selectedPrice, product.currency) }}
            </span>
            }
            }
            <mat-form-field appearance="outline" class="w-full md:w-[170px]">
              <mat-select
                [value]="product.selectedSize"
                (selectionChange)="onSizeChange(product, $event)"
                [disabled]="!product.selectedSize || !product._isAvailable">
                @for (option of productSizeOptions.get(product) || []; track trackBySize($index, option)) {
            <mat-option [value]="option.size">
              {{ option.size }}
            </mat-option>
            }
            </mat-select>
          </mat-form-field>
        </div>
            }

            <!-- ── Single price ── -->
            @if (!hasMultiplePrices(product)) {
            <div class="text-center">
              @if (discountInfo && !isRedeemMode) {
            @if (product.price && !isNaN(product.price)) {
            <div class="flex flex-col items-center">
              <span class="text-[13px] line-through text-site">
            {{ displayPrice(product.price, product.currency) }}
            </span>
            <span class="text-[16px] font-bold text-red-500 whitespace-nowrap">
            {{ displayPrice(calculateDiscountedPrice(product.price, discountInfo.reduction), product.currency) }}
            </span>
          </div>
            }
            } @else {
            @if (product.price && !isNaN(product.price)) {
            <span class="text-[16px] font-bold text-dark">
            {{ displayPrice(product.price, product.currency) }}
            </span>
            }
            }
            @if (!product.price || isNaN(product.price)) {
            <span class="text-[16px] font-bold text-gray-400">
                    Chargement...
                  </span>
            }
            </div>
            }

            <div class="mt-auto">
              @if (getButtonType(product) === 'button') {
              <button
                [disabled]="!product._isAvailable"
                [matButton]="themeConfig.appearance.button.action"
                class="w-full"
                (click)="addProductToCart(product)">
                Ajouter au panier
              </button>
              } @else {
              <a
                [matButton]="themeConfig.appearance.button.action"
                class="product-btn w-full"
                [class.no-hover]="hasAdditions(product) || !product._isAvailable"
                (click)="!product._isAvailable ? $event.preventDefault() : (hasAdditions(product) ? navigateToProductDetailsSideEffect(product) : $event.preventDefault())">
                <span class="default-text">Personnaliser</span>

                @if (!hasAdditions(product)) {
              <div class="hover-text">
                      <span
                        (click)="$event.stopPropagation(); product._isAvailable && navigateToProductDetailsSideEffect(product)">
                        Personnaliser
                      </span>
                <span (click)="$event.stopPropagation(); product._isAvailable && addProductToCart(product)">
                        | Ajouter
                      </span>
              </div>
              }
              </a>
              }
            </div>
          </div>
        </div>
        }
        </div>
        }

        @if (totalPages > 1) {
        <div class="flex justify-center items-center mt-6">
          <button
            class="px-2 py-2 rounded bg-secondary text-white disabled:opacity-50"
            (click)="prevPage()"
            [disabled]="page === 0">
            ← Précédent
          </button>
          <span class="px-4 py-2 font-bold">
            Page {{ page + 1 }} / {{ totalPages }}
        </span>
        <button
          class="px-2 py-2 rounded bg-secondary text-white disabled:opacity-50"
          (click)="nextPage()"
          [disabled]="page + 1 >= totalPages">
          Suivant →
        </button>
      </div>
        }
      </div>
    </div>
    }
    </div>
    }
    <!-- ═══ RÉSULTATS FILTRÉS ═══ -->
    @if (isFiltersActive) {
    <div class="px-2 mt-4">

      <!-- Indicateur des filtres actifs -->
      @if (activeFilterLabels.plus.length > 0 || activeFilterLabels.minus.length > 0) {
    <div class="mb-6 text-center text-base">
      <span class="text-[#7A370D] font-bold">Liste de produits </span>
      @if (activeFilterLabels.plus.length > 0) {
      <span>
        <span class="text-green-600 font-bold">qui contient : </span>
        <span class="text-[#7A370D]">{{ activeFilterLabels.plus.join(", ") }}</span>
        </span>
      }
      @if (activeFilterLabels.minus.length > 0) {
      <span>
        @if (activeFilterLabels.plus.length > 0) {
      <span class="text-dark">—</span>
      }
      <span class="text-red-500 font-bold">ne contient pas : </span>
      <span class="text-[#7A370D]">{{ activeFilterLabels.minus.join(", ") }}</span>
        </span>
      }
    </div>
    }

    <!-- Chargement en cours -->
    @if (isLoading()) {
    <div class="flex justify-center items-center min-h-[300px]">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-secondary"></div>
      <span class="ml-2 text-gray-600">Recherche des produits...</span>
    </div>
    }

    <!-- Aucun produit trouvé -->
    @if (!isLoading() && productsByCategory.length === 0) {
    <div class="flex flex-col justify-center items-center py-12">
      <p class="text-gray-600 text-lg font-medium">
        Aucun produit ne correspond à vos filtres.
      </p>
    </div>
    }

    <!-- Grille des produits filtrés identique aux catégories -->
    @if (!isLoading() && productsByCategory.length > 0) {
    <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
      @for (product of productsByCategory; track trackByProductId(product)) {
      <div
        class="bg-base-200 rounded-box overflow-hidden transition-all duration-300 flex flex-col relative max-h-[450px] w-full"
        [class.is-disabled]="!product._isAvailable">
        @if (!product._isAvailable) {
      <div class="absolute inset-0 backdrop-blur-[1px] bg-white/40 z-30 rounded-box pointer-events-none"></div>
      }
      @if (product._availabilityLabel) {
      <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40
                      bg-[#ffffffb8] text-badge text-[#000000] font-bold px-3 py-2 rounded-xl shadow-md uppercase text-center
                      custom-phone-badge border border-gray-300">
        {{ product._availabilityLabel }}
      </div>
      }
      @let discountInfo = getProductDiscountInfo(product.id, product.selectedSize, product.categoryId);

      <!-- ═══ DISCOUNT BADGES ══════════ -->
      @if (discountInfo && !isRedeemMode) {
      @if (formatReduction(discountInfo.reduction)) {
      <div class="absolute top-2 left-2 z-20">
            <span class="bg-[#EB3D08] text-white text-xs font-bold px-2 py-1 rounded-full shadow-md">
      {{ formatReduction(discountInfo.reduction) }}
      </span>
</div>
      }
      @if (getDiscountClientBadge(discountInfo.activatedFor); as clientBadge) {
      <div class="absolute top-2 right-2 z-20">
            <span
              class="bg-secondary text-white text-xs font-bold px-2 py-1 rounded-full tracking-wider shadow-md border-b border-white/10 animate-pulse">
      {{ clientBadge.label }}
      </span>
</div>
      }
      }

      <div class="relative w-full h-[200px] overflow-hidden rounded-[12px] p-3">
        <img
          [ngSrc]="product.cover || 'assets/images/placeholders/placeholder.webp'"
          [alt]="product.name || 'Image à venir'"
          fill
          loading="lazy"
          sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
          class="object-contain rounded-[12px]"/>
      </div>

      <div class="px-3 pb-3 space-y-3 flex flex-col flex-1">
        <h3 class="font-bold text-[16px] md:text-[18px] text-dark text-center">
      {{ product.name }}
      </h3>

      <!-- ── Multiple sizes ── -->
      @if (hasMultiplePrices(product)) {
      <div class="flex flex-col md:flex-row items-center justify-between gap-2">
        @if (discountInfo && !isRedeemMode) {
        @if (product.selectedPrice && !isNaN(product.selectedPrice)) {
        <div class="flex flex-col items-start">
                <span class="text-[13px] line-through text-site whitespace-nowrap">
                  {{ displayPrice(product.selectedPrice, product.currency) }}
                </span>
          <span class="text-[16px] font-bold text-red-500 whitespace-nowrap">
                  {{ displayPrice(calculateDiscountedPrice(product.selectedPrice, discountInfo.reduction), product.currency) }}
                </span>
        </div>
        }
        } @else {
        @if (product.selectedPrice && !isNaN(product.selectedPrice)) {
        <span class="text-[16px] font-bold text-dark whitespace-nowrap">
                {{ displayPrice(product.selectedPrice, product.currency) }}
              </span>
        }
        }
        <mat-form-field appearance="outline" class="w-full md:w-[170px]">
          <mat-select
            [value]="product.selectedSize"
            (selectionChange)="onSizeChange(product, $event)"
            [disabled]="!product.selectedSize || !product._isAvailable">
            @for (option of productSizeOptions.get(product) || []; track trackBySize($index, option)) {
            <mat-option [value]="option.size">
            {{ option.size }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }

      <!-- ── Single price ── -->
      @if (!hasMultiplePrices(product)) {
      <div class="text-center">
        @if (discountInfo && !isRedeemMode) {
        @if (product.price && !isNaN(product.price)) {
        <div class="flex flex-col items-center">
                <span class="text-[13px] line-through text-site">
                  {{ displayPrice(product.price, product.currency) }}
                </span>
          <span class="text-[16px] font-bold text-red-500 whitespace-nowrap">
                  {{ displayPrice(calculateDiscountedPrice(product.price, discountInfo.reduction), product.currency) }}
                </span>
        </div>
        }
        } @else {
        @if (product.price && !isNaN(product.price)) {
        <span class="text-[16px] font-bold text-dark">
                {{ displayPrice(product.price, product.currency) }}
              </span>
        }
        }
        @if (!product.price || isNaN(product.price)) {
        <span class="text-[16px] font-bold text-gray-400">
          Chargement...
        </span>
        }
      </div>
      }

      <!-- ── Action buttons ── -->
      <div class="mt-auto">
        @if (getButtonType(product) === 'button') {
      <button
        [disabled]="!product._isAvailable"
        [matButton]="themeConfig.appearance.button.action"
        class="w-full"
        (click)="addProductToCart(product)">
        Ajouter au panier
      </button>
      } @else {
      <a
        [matButton]="themeConfig.appearance.button.action"
        class="product-btn w-full"
        [class.no-hover]="hasAdditions(product) || !product._isAvailable"
        (click)="!product._isAvailable ? $event.preventDefault() : (hasAdditions(product) ? navigateToProductDetailsSideEffect(product) : $event.preventDefault())">
        <span class="default-text">Personnaliser</span>

        @if (!hasAdditions(product)) {
        <div class="hover-text">
          <span (click)="$event.stopPropagation(); product._isAvailable && navigateToProductDetailsSideEffect(product)">
            Personnaliser
          </span>
          <span (click)="$event.stopPropagation(); product._isAvailable && addProductToCart(product)">
            | Ajouter
          </span>
        </div>
        }
      </a>
      }
      </div>
    </div>
  </div>
      }
    </div>
    }

    @if (totalPages > 1) {
    <div class="flex justify-center items-center mt-6">
      <button
        class="px-2 py-2 rounded bg-secondary text-white disabled:opacity-50"
        (click)="prevPage()"
        [disabled]="page === 0">
        ← Précédent
      </button>
      <span class="px-4 py-2 font-bold">Page {{ page + 1 }} / {{ totalPages }}</span>
      <button
        class="px-2 py-2 rounded bg-secondary text-white disabled:opacity-50"
        (click)="nextPage()"
        [disabled]="page + 1 >= totalPages">
        Suivant →
      </button>
    </div>
    }
    </div>
    }
  </div>
</div>
@if (loyaltyPointEnabled()) {
<div class="fixed bottom-20 right-10 z-50 flex items-center justify-center w-14 h-14 animate-slide-down">

<span class="absolute inline-flex h-full w-full rounded-full bg-primary opacity-75 animate-ping"></span>

<button
type="button"
[matTooltip]="'Points fidélité disponibles: ' + availablePoints"
(click)="openLoyaltyDialog()"
class="relative flex items-center justify-center w-14 h-14 rounded-full bg-primary text-white shadow-2xl hover:scale-110 transition-transform duration-300 cursor-pointer">

<mat-icon class="material-symbols-outlined text-2xl">star</mat-icon>

<span class="absolute -top-1 -right-1 flex items-center justify-center min-w-[22px] h-[22px] px-1 text-xs font-bold text-white bg-red-600 border-2 border-white rounded-full shadow-md">
{{ availablePoints }}
</span>
</button>
</div>
}
